import { computed } from "vue";
import { BFieldSelection, BFilterableField, listOperations, textOperations } from "./components/BFilterEditor/BFilterEditor.types";
import { BTableColumn } from "./components/BTable/BTable.types";

export const defaultStatisticsColumns = [
    {
        key: "type",
        text: "",
        sortable: false,
        value: (item) => item.type,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "submitted",
        text: "Submitted",
        sortable: false,
        value: (item) => item.submitted,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "rejected",
        text: "Rejected",
        sortable: false,
        value: (item) => item.rejected,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "rejectionRate",
        text: "Rejection Rate",
        sortable: false,
        value: (item) => item.rejectionRate,
        columnClass: ["text-center"],
        class: (item) => ["align-center"],
    },
] as BTableColumn[];


export const defaultDataUploadDetailsColumns = [
    {
        key: "incidentNumber",
        text: "Incident Number",
        sortable: true,
        value: (item) => item["incidentNumber"],
    },
    {
        key: "lineNumber",
        text: "Line Number",
        sortable: true,
        columnClass: ["d-none"],
        class: (item) => ["d-none"],
        value: (item) => item["lineNumber"],
    },
    {
        key: "errorCode",
        text: "Error Code",
        sortable: true,
        value: (item) => item["errorCode"],
    },
    {
        key: "errorType",
        text: "Type",
        sortable: true,
        value: (item) => item["errorType"],
    },
    {
        key: "description",
        text: "Description",
        sortable: true,
        value: (item) => item.description,
    }] as BTableColumn[];

export const defaultValidationMessagesColumns = [
    {
        key: "lineNumber",
        text: "Line Number",
        sortable: true,
        value: (item) => item.lineNumber,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "errorCode",
        text: "Error Code",
        sortable: true,
        value: (item) => item.errorCode,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "description",
        text: "Description",
        sortable: true,
        value: (item) => item.description,
        columnClass: ["text-start"],
        class: (item) => ["align-start", "text-wrap"],
    },
] as BTableColumn[];

export const defaultValidationMessagesFilterableFields = [
    {
        property: "lineNumber",
        label: "Line Number",
        operations: textOperations,
        editorComponent: "text-editor",
    },
    {
        property: "errorCode",
        label: "Error Code",
        operations: textOperations,
        editorComponent: "text-editor",
    },
    {
        property: "description",
        label: "Description",
        operations: textOperations,
        editorComponent: "text-editor",
    }
] as BFilterableField[];

export const statusFilters = [{
    text: "Cleared",
    value: "Cleared",
},
{
    text: "Dismissed",
    value: "Dismissed",
},
{
    text: "Unresolved",
    value: "Unresolved",
}] as BFieldSelection[];

export const fileStatusFilters = [
{
    text: "Completed",
    value: "Completed",
},
{
    text: "Completed With Errors And Warnings",
    value: "CompletedWithErrorsAndWarnings",
},
{
    text: "Completed With Errors",
    value: "CompletedWithErrors",
},
{
    text: "Completed With Warnings",
    value: "CompletedWithWarnings",
},
{
    text: "Failed",
    value: "Failed",
},
{
    text: "Pending",
    value: "Pending",
},
]
export const getTypes = [
{ text: "Error", value: 0 },
{ text: "Warning", value: 1 },
] as BFieldSelection[];

export const validationMessagesFilterableFields = [{
    property: "lineNumber",
    label: "Line Number",
    operations: textOperations,
    editorComponent: "text-editor",
},
{
    property: "errorCode",
    label: "Error Code",
    operations: textOperations,
    editorComponent: "text-editor",
},
{
    property: "description",
    label: "Description",
    operations: textOperations,
    editorComponent: "text-editor",
}] as BFilterableField[]

export const statisticsColumns = [
    {
        key: "type",
        text: "",
        sortable: false,
        value: (item) => item.type,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "submitted",
        text: "Submitted",
        sortable: false,
        value: (item) => item.submitted,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "rejected",
        text: "Rejected",
        sortable: false,
        value: (item) => item.rejected,
        columnClass: ["text-center"],
        class: (item) => ["text-center"],
    },
    {
        key: "rejectionRate",
        text: "Rejection Rate",
        sortable: false,
        value: (item) => item.rejectionRate,
        columnClass: ["text-center"],
        class: (item) => ["align-center"],
    },
] as BTableColumn[]